module.exports = __webpack_public_path__ + "static/Fernando_Jansenson-720838cb5e9e7a5bb7327f3f9558c540.webp";